import './InfoCard.scss';

interface IProps {
	heading: string;
	text?: string;
	image?: string;
}
const InfoCard: React.FC<IProps> = ({ heading, text, image }) => {
	return (
		<div className="infoCard">
			<div className="infoCard__head">
				<h3 className="infoCard__heading">{heading}</h3>
				{text && <div className="infoCard__text">{text}</div>}
			</div>
			{image && (
				<div className="infoCard__image-container">
					<img src={image} alt="Image" className="infoCard__image" />
				</div>
			)}
		</div>
	);
};

export default InfoCard;
